import { useRouter } from 'next/router';

import SavedFiltersButton from './SavedFiltersButton';

interface Props {
  preservedFilterKeys?: string[];
}

/**
 * Component that displays a dropdown with user's saved filters
 * When applying filters, it will always preserve the search query
 * and any other query key in the preservedFilterKeys array. It
 * will also reset the page to 1.
 *
 * @param preservedFilterKeys - Array of query keys to preserve when applying filters
 */
const SavedFilters = ({ preservedFilterKeys = [] }: Props) => {
  const router = useRouter();

  const handleApplyFilter = (filterQuery: string) => {
    try {
      // Parse the filter query string back into params
      const params = new URLSearchParams(filterQuery);

      // keep search and any other query key in the preservedFilterKeys array
      const preservedFilters = {
        ...(router.query?.search ? { search: router.query.search } : {}),
        ...preservedFilterKeys.reduce((acc, key) => {
          if (router.query[key]) acc[key] = router.query[key];
          return acc;
        }, {} as Record<string, (typeof router.query)[string]>)
      };

      // Apply new filters and reset the page to 1
      const newQuery: typeof router.query = {
        ...Object.fromEntries(params.entries()),
        ...preservedFilters,
        page: '1'
      };

      // Update the URL with the new filters
      router.replace({ query: newQuery }, undefined, { shallow: true });
    } catch (err) {
      console.error('Failed to apply filters:', err);
    }
  };

  return (
    <div className="saved-filters">
      <SavedFiltersButton onApplyFilter={handleApplyFilter} />
    </div>
  );
};

export default SavedFilters;
